import { Injectable, inject } from '@angular/core';

import { select, Store } from '@ngrx/store';

import * as UploadActions from './upload.actions';
import * as UploadSelectors from './upload.selectors';
import { UploadFacade } from '@dges/modules/storage/domain';

@Injectable()
export class FirebaseUploadFacade implements UploadFacade {
  private store = inject(Store);

  /**
   * Combine pieces of state using createSelector,
   * and expose them as observables through the facade.
   */
  loaded$ = this.store.pipe(select(UploadSelectors.getUploadLoaded));
  allUpload$ = this.store.pipe(select(UploadSelectors.getAllUpload));
  selectedUpload$ = this.store.pipe(select(UploadSelectors.getSelected));

  /**
   * Use the initialization action to perform one
   * or more tasks in your Effects.
   */
  upload(files: File[], folderName: string) {
    this.store.dispatch(
      UploadActions.upload({ files: files, folderName: folderName }),
    );
  }

  cleanUploads() {
    this.store.dispatch(UploadActions.cleanUploads());
  }
}
